module.exports = __webpack_public_path__ + "static/media/dr_henley_morgan.daee8bab.pdf";